import { DomainsVerifiable } from "../enums/domains-verifiable.enum";
import { InstagramTabVerifier } from "../services/instagram-tab-verifier.service";
import { OzonTabVerifier } from "../services/ozon-tab-verifier.service";
import { TabVerifier } from "../services/tab-verifier.service";
import { VkontakteTabVerifier } from "../services/vkontakte-tab-verifier.service";
import { WildberriesTabVerifier } from "../services/wildberries-tab-verifier.service";

export function tabVerify(url: URL): TabVerifier {

  switch (url.hostname) {

    case DomainsVerifiable.instagram:
      return new InstagramTabVerifier(url);

    case DomainsVerifiable.ozon:
      return new OzonTabVerifier(url);

    case DomainsVerifiable.vkontakte:
      return new VkontakteTabVerifier(url);

    case DomainsVerifiable.wildberries:
      return new WildberriesTabVerifier(url);

  }

}
